import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { ADMIN_AUTH_COOKIE_NAME } from '@constants';

export const useGetAdminToken = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');

    if (token) {
      Cookies.set(ADMIN_AUTH_COOKIE_NAME, token);
      navigate(location.pathname, { replace: true });
    }
  }, [location, navigate]);
};
